<template>
  <keep-alive>
    <b-modal
        :id="id"
        ref="modal"
        :title="modalTitle"
        no-close-on-backdrop
        title-class="font-18"
        v-bind="$attrs"
        @ok="handleOk"
        @close="handleClose"
    >
      <validation-observer v-if="!loading" ref="form_observer">
        <component
            :is="form"
            ref="form"
            v-model="model"
            :errors="errors"
            :is-valid.sync="isValid"
            is-modal="true"
            v-bind="formProps"
            v-on="formListeners"
        >
        </component>
      </validation-observer>
      <div v-if="loading" class="d-flex">
        <i class="bx bx-loader bx-spin font-size-16 align-middle mx-auto"></i>
      </div>
      <template #modal-footer="{ ok, cancel}">
        <b-button size="md" variant="outline-dark" @click="cancel()">
          Batal
        </b-button>
        <b-button
            :disabled="updating || loading"
            size="md"
            variant="primary"
            @click="ok()"
        >
          <i
              v-if="updating"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
          ></i>
          Simpan
        </b-button>
      </template>
    </b-modal>
  </keep-alive>
</template>

<script>
import FormsModel from "@/components/forms/customer";
import MultiselectAjax from "@/components/inputs/vue-multiselect-ajax";
import ModelCreateModal from "@/components/modals/modal-create.vue";
import Swal from "sweetalert2";
import { buildCustomerPayload } from "@/services/transformers/customerPayload";

function createDefaultFarm() {
  return {
    use_jala_farm: true,
    get coordinate() {
      return this.latitude
          ? `${this.latitude},${this.longitude}`
          : null;
    },
    set coordinate(value) {
      if (value) {
        const [lat, lng] = (value || "").split(",");
        if (lat != null && Number(lat) && lng != null && Number(lng)) {
          this.latitude = Number(lat);
          this.longitude = Number(lng);
        }
      } else {
        this.latitude = null;
        this.longitude = null;
      }
    },
  };
}

function createDefaultModel(initialValue = {}) {
  return {
    ...initialValue,
    farms: [createDefaultFarm()],
  };
}

export default {
  extends: ModelCreateModal,
  components: {
    MultiselectAjax,
  },
  props: {
    id: {type: String, required: true},
    modalTitle: {
      default() {
        return this.lodash.startCase(this.$t("customers.singular"));
      },
    },
    resourceRoute: {default: "models"},
    modelVariable: {default: "model"},
    form: {
      type: Object,
      default: function () {
        return FormsModel;
      },
    },
    formProps: {
      type: Object,
      default: function () {
        return {};
      },
    },
    formListeners: {
      type: Object,
      default: function () {
        return {};
      },
    },
    initialValue: {
      type: Object,
      default() {
        return {};
      },
    },
    denyCustomerSelect: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      loading: false,
      isValid: true,
      updating: false,
      model: createDefaultModel(this.initialValue),
      errors: {},
      registered:
          this.initialValue?.registered !== undefined
              ? this.initialValue.registered
              : true,
    };
  },
  methods: {
    resetModel() {
      this.$set(this, 'model', createDefaultModel(this.initialValue));
      this.errors = {};
    },
    handleOk(event) {
      event.preventDefault();
      if (!('validateAll' in this.$refs.form)) return;
      this.$refs.form.validateAll().then((isValids) => {
        this.isValid = isValids.every((isValid) => isValid === true);
        if (this.isValid) {
          this.$nextTick(() => {
            this.handleStore(this.model)
          })
        }
      })
    },
    handleClose() {
      this.resetModel();
    },
    handleStore(value) {
      this.loading = true;
      const payload = buildCustomerPayload(value);
      this.errors = {};
      return this.store(payload).then((res) => {
        const {data: {data}} = res
        if (data) {
          let something = 'Pelanggan';
          let id = (data || {}).id;
          return Swal.fire({
            title: this.$t('Success') + '!',
            text: this.$t(`You've added {something} with id {id}`, {something, id}),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.$emit('created', data)
            this.$refs.modal.hide()
            this.resetModel()
          })
        }
      }).catch((error) => this.failedAlert(error)).finally(() => {
        this.loading = false;
      })
    },
    store(value) {
      return this.$axios.post('/customers', value)
    },
    delete() {
      // return this.$axios.delete(`/customers/${value.id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .modal-title {
    font-weight: 800;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.05em;
    color: #0084f3;
  }

  .modal-dialog {
    max-width: 720px !important;
  }

  .col-form-label {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #6c7589;
  }
}
</style>
